var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavaScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.464 0.5H7.91607C3.96119 0.5 0.755127 3.72355 0.755127 7.7V17.3C0.755127 21.2765 3.96119 24.5 7.91607 24.5H17.464C21.4189 24.5 24.6249 21.2765 24.6249 17.3V7.7C24.6249 3.72355 21.4189 0.5 17.464 0.5Z",
    fill: "#E6C803"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_2076",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3203 2.81689H2.89526V22.3479H22.3203V2.81689Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_2076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89526 2.81689H22.3203V22.3479H2.89526V2.81689Z",
    fill: "#E6C803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7307 17.69C20.5885 16.7988 20.0105 16.0506 18.2988 15.3525C17.7043 15.0778 17.0414 14.881 16.8438 14.428C16.7736 14.1644 16.7644 14.0158 16.8087 13.8561C16.9361 13.3382 17.551 13.1766 18.0385 13.3252C18.3524 13.431 18.6497 13.6742 18.8288 14.0622C19.6671 13.5164 19.6653 13.5201 20.2506 13.1451C20.0364 12.8109 19.9219 12.6568 19.7816 12.5139C19.2775 11.9477 18.5906 11.6562 17.4919 11.6784C17.3017 11.7026 17.1097 11.7285 16.9195 11.7527C16.3711 11.8919 15.8485 12.1815 15.542 12.5696C14.6225 13.6185 14.8847 15.4547 16.0036 16.2103C17.106 17.042 18.7254 17.2314 18.9322 18.0093C19.1334 18.9617 18.236 19.2699 17.3442 19.1604C16.6868 19.023 16.3213 18.687 15.9261 18.0761C15.1986 18.4994 15.1986 18.4994 14.4508 18.932C14.628 19.3219 14.8145 19.4983 15.1118 19.8362C16.5189 21.2713 20.0401 21.2007 20.6716 19.0286C20.6974 18.9543 20.8673 18.4567 20.7307 17.69ZM13.4555 11.7935H11.6386C11.6386 13.3716 11.6312 14.9385 11.6312 16.5166C11.6312 17.521 11.6829 18.4419 11.5204 18.7241C11.2545 19.2792 10.5657 19.2105 10.2518 19.1028C9.9324 18.945 9.76991 18.7203 9.58158 18.4029C9.5299 18.3119 9.49111 18.2414 9.47816 18.2358C8.98513 18.5384 8.49395 18.8429 8.00098 19.1455C8.24654 19.6523 8.60846 20.0924 9.0719 20.3783C9.76436 20.796 10.695 20.9241 11.6681 20.6994C12.3015 20.5138 12.848 20.1295 13.1342 19.5447C13.5478 18.7779 13.4592 17.8496 13.4555 16.823C13.4647 15.1483 13.4555 13.4737 13.4555 11.7935Z",
    fill: "#323330"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScript);
export default __webpack_public_path__ + "static/media/javaScript.6bf5a7eeb37c9f1a9a476609f511e047.svg";
export { ForwardRef as ReactComponent };